import './App.css';
import Countries from './components/Countries';
import Header from './components/Header';

function App() {
  return (
    <>
      <Header />
      <Countries />
    </>
  );
}



export default App;
